import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Box,
  Typography,
} from "@mui/material";
import meetSharif  from "../images/about_deb_bg.jpg";

const EmailSignupModal = ({ open, handleClose }) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <Box sx={{ background: "#106cb7!important" }}>
        <DialogTitle sx={{ color: "white" }}>Join Our Email List</DialogTitle>
        <DialogContent>
          <form
            action="https://api.web3forms.com/submit"
            method="POST"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              paddingTop: "1rem",
            }}
          >
            <input
              type="hidden"
              name="access_key"
              value="cbee500a-aca1-424f-b45b-51aa780c842e"
            />
            <TextField
              label="First Name"
              name="first_name"
              required
              fullWidth
              sx={{ background: "#FFFFFF", borderRadius: "4px" }}
            />
            <TextField
              label="Last Name"
              name="last_name"
              required
              fullWidth
              sx={{ background: "#FFFFFF", borderRadius: "4px" }}
            />
            <TextField
              label="Email"
              name="email"
              type="email"
              required
              fullWidth
              sx={{ background: "#FFFFFF", borderRadius: "4px" }}
            />
            <TextField
              label="Phone"
              name="phone"
              fullWidth
              sx={{ background: "#FFFFFF", borderRadius: "4px" }}
            />
            <TextField
              label="Zip Code"
              name="zip"
              fullWidth
              sx={{ background: "#FFFFFF", borderRadius: "4px" }}
            />
            <Box mt={2}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                fullWidth
                sx={{
                  background: "#014991",
                  borderRadius: "4px",
                  color: "#FFFFFF",
                  fontSize: "18px",
                  fontWeight: "bold",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: "#FFFFFF",
                  borderRadius: "4px",
                  color: "#014991",
                  },
                }}
              >
                Submit
              </Button>
            </Box>
            <Typography
              variant="body2"
              sx={{ color: "white" }}
              align="center"
              mt={2}
            >
              Join our email list keep up to date with the latest from Sharif!
            </Typography>
          </form>
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default EmailSignupModal;
